export const UserMenuItemId = Object.freeze({
    "GLOBAL_SETTINGS": "open-settings",
    "CREATE_ORG": "create-organization",
    "ORGS": "user-organizations",
});